import { Skeleton } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const SkeletonLoader = () => {
  return (
    <Box sx={{ px: 2, pb: 10 }}>
      <Box sx={{ mb: 3 }}>
        <Box
          sx={{ height: 40, bgcolor: "rgba(0,0,0,0.06)", borderRadius: 1 }}
        />
      </Box>

      <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Box
            key={i}
            sx={{
              width: 110,
              height: 36,
              bgcolor: "rgba(0,0,0,0.06)",
              borderRadius: 1.5,
            }}
          />
        ))}
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
          gap: 2,
        }}
      >
        {Array.from({ length: 9 }).map((_, i) => (
          <Box
            key={i}
            sx={{
              borderRadius: 2,
              p: 2,
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.95), rgba(250,250,252,0.98))",
              boxShadow: "0 8px 28px rgba(2,6,23,0.06)",
              display: "grid",
              gridTemplateRows: "auto 1fr auto",
              gap: 1.25,
            }}
            aria-busy="true"
            aria-live="polite"
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr auto",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Skeleton
                variant="rectangular"
                width={80}
                height={28}
                sx={{ borderRadius: 1.5 }}
              />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Skeleton variant="circular" width={18} height={18} />
                <Skeleton variant="text" width={120} height={20} />
              </Box>
            </Box>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "auto 1fr",
                gap: 1.25,
                alignItems: "center",
              }}
            >
              <Skeleton variant="circular" width={56} height={56} />
              <Box sx={{ display: "grid", gap: 0.5 }}>
                <Skeleton variant="text" width="60%" height={28} />
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  <Skeleton variant="text" width={100} height={18} />
                  <Skeleton variant="text" width={8} height={18} />
                  <Skeleton variant="text" width={80} height={18} />
                  <Skeleton variant="text" width={8} height={18} />
                  <Skeleton variant="text" width={90} height={18} />
                </Box>
              </Box>
            </Box>

            <Box sx={{ display: "grid", gap: 1 }}>
              <Box sx={{ display: "flex", gap: 0.75 }}>
                <Skeleton variant="text" width={64} height={18} />
                <Skeleton variant="text" width="70%" height={18} />
              </Box>

              <Skeleton variant="text" width="50%" height={18} />

              <Box>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={6}
                  sx={{ borderRadius: 1 }}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 0.5,
                  }}
                >
                  <Skeleton variant="text" width={120} height={14} />
                  <Skeleton variant="text" width={80} height={14} />
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SkeletonLoader;
